/**
 * Taabiir Countdown Timer — deferred companion to sections/custom-countdown.liquid
 * Initialises every .tb-countdown section on the page (multi-instance safe).
 * The target date is read from the section's data-end-date attribute.
 */
(function () {
  function initCountdown(section) {
    if (!section || section.dataset.countdownInit === 'true') return;
    var endDate = section.dataset.endDate;
    if (!endDate) return;
    section.dataset.countdownInit = 'true';

    var end = new Date(endDate).getTime();
    var timer = section.querySelector('[data-countdown-timer]');
    var expired = section.querySelector('[data-countdown-expired]');
    var d = section.querySelector('[data-countdown-days]');
    var h = section.querySelector('[data-countdown-hours]');
    var m = section.querySelector('[data-countdown-minutes]');
    var s = section.querySelector('[data-countdown-seconds]');

    function pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    function update() {
      var now = Date.now();
      var diff = end - now;
      if (diff <= 0) {
        timer.hidden = true;
        if (expired) expired.hidden = false;
        clearInterval(interval);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (d) d.textContent = pad(days);
      if (h) h.textContent = pad(hours);
      if (m) m.textContent = pad(mins);
      if (s) s.textContent = pad(secs);
    }

    update();
    var interval = setInterval(update, 1000);
  }

  function initScope(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('.tb-countdown')) initCountdown(root);
    root.querySelectorAll('.tb-countdown').forEach(initCountdown);
  }

  initScope(document);
  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });
})();
